/**
 * Fragment de routes du paquet v3-p06-ecrans-elements (vague V3). Composants chargés à la demande (règle de
 * chargement du registre).
 *  - Remplacements du socle (`couvre: route:` des YAML) : `/backlog`, `/tree`, `/graph` (alias historiques vers
 *    `/projet?vue=…`) → projet-elements (affichage liste, hiérarchie, graphe) ; `/items/:id` (écran historique
 *    `ItemDetail`) → projet-element-fiche.
 *  - Dialogues en écran plein (routes neuves) : `/backlog/nouveau` (créer ; `?parent=&niveau=&origine=`),
 *    `/items/:id/suppression`, `/items/:id/fusion`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetElements = lazy(() => import('../ecrans/v3/elements/ProjetElements').then((m) => ({ default: m.ProjetElements })))
const ProjetElementFiche = lazy(() => import('../ecrans/v3/elements/ProjetElementFiche').then((m) => ({ default: m.ProjetElementFiche })))
const DialogueCreer = lazy(() => import('../ecrans/v3/elements/DialogueCreerElement').then((m) => ({ default: m.DialogueCreerElement })))
const DialogueSupprimer = lazy(() => import('../ecrans/v3/elements/DialogueSupprimerElement').then((m) => ({ default: m.DialogueSupprimerElement })))
const DialogueFusionner = lazy(() => import('../ecrans/v3/elements/DialogueFusionnerElement').then((m) => ({ default: m.DialogueFusionnerElement })))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v3-elements',
  routes: [
    { chemin: '/backlog', element: ecran(ProjetElements), remplace: true },
    { chemin: '/tree', element: ecran(ProjetElements), remplace: true },
    { chemin: '/graph', element: ecran(ProjetElements), remplace: true },
    { chemin: '/items/:id', element: ecran(ProjetElementFiche), remplace: true },
    { chemin: '/backlog/nouveau', element: ecran(DialogueCreer) },
    { chemin: '/items/:id/suppression', element: ecran(DialogueSupprimer) },
    { chemin: '/items/:id/fusion', element: ecran(DialogueFusionner) },
  ],
}
